import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="border-t border-black/5 mt-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <Logo tagline />
          <p className="text-sm text-neutral-600 max-w-xs leading-relaxed mt-4">
            When you need a helping hand, book a real mate — with an extra pair of two hands.
          </p>
          <div className="mt-4 text-xs text-neutral-500">www.heylpmate.com</div>
        </div>
        <div>
          <div className="label-eyebrow mb-3">Popular Assists</div>
          <ul className="space-y-1.5 text-sm text-neutral-700">
            <li>Airport Assist</li>
            <li>Hospital Assist</li>
            <li>Baby Care & Old-age</li>
            <li>Shopping Assist</li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-3">Company</div>
          <ul className="space-y-1.5 text-sm text-neutral-700">
            <li><a href="/about" className="hover:text-[color:var(--secondary)]">How it works</a></li>
            <li><a href="/about" className="hover:text-[color:var(--secondary)]">About HeylpMate</a></li>
            <li><a href="/corporate" className="hover:text-[color:var(--secondary)]">Corporate / Exhibition</a></li>
            <li><a href="/become-mate" className="hover:text-[color:var(--secondary)]">Become a Mate</a></li>
            <li><a href="/membership" className="hover:text-[color:var(--secondary)]">Priority Membership</a></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-3">Trust</div>
          <ul className="space-y-1.5 text-sm text-neutral-700">
            <li>Verified mates, ID-checked</li>
            <li>Transparent commission</li>
            <li>Ratings after every task</li>
            <li>Instant WhatsApp support</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-black/5">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row justify-between text-xs text-neutral-500">
          <div>© {new Date().getFullYear()} HeylpMate. All rights reserved.</div>
          <div>On the Go · Anytime · Anywhere · Minutes or Hours.</div>
        </div>
      </div>
    </footer>
  );
}
